import React from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules, getTestId } from '@utils';

import CopyText from '@containers/CopyText';

import style from './Address.scss';

const cn = bemCssModules(style, 'Address');
const ti = getTestId('Address');

const SLICE_LENGTH = 6;

export type TAddress = {
  value: string;
};

const Address: CustomFC<TAddress> = ({ className, value }) => {
  const { t } = useTranslation();

  return (
    <small className={cn(null, [className])} data-testid={ti()}>
      <div>{t('deposit.wallet_address')}</div>
      <CopyText className={cn('copy')} text={value} title={value}>
        <div className={cn('ellipsis-block')}>
          <div className={cn('ellipsis')}>{value.slice(0, -SLICE_LENGTH)}</div>
          <div>{value.slice(-SLICE_LENGTH)}</div>
        </div>
      </CopyText>
    </small>
  );
};

export default Address;
